import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {LOCKABLE_ENTITY_TYPE_LINKVIEW} from "./lockable-entity-type.constant";
import type {LockEntityPayload} from "./lock-entity.command";

/**
 * Gives the edit lock back. Same payload as acquiring: `{ entityType, uid }`.
 *
 * Its own command rather than a side effect of saving — cancelling an edit needs
 * it anyway, coupling it to a save would make intermediate saves impossible, and
 * a command is an intention rather than a by-product.
 *
 * The backend GUARDS this on the holder: releasing a lock somebody else holds is
 * refused. Without that guard, release-then-acquire would be an unguarded side
 * door around the entire take-over warning.
 */
export class ReleaseEntityLockCommand extends AbstractCommand<LockEntityPayload> {

    public name = CommandName.RELEASE_ENTITY_LOCK;

    public tags: string[] = [`entity`, `lock`, LOCKABLE_ENTITY_TYPE_LINKVIEW];

    constructor(payload: LockEntityPayload) {
        super(payload.entityType, payload.uid, payload);
    }
}
